(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-trade-show-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trade-show-timeline')) {
    customElements.define('trade-show-timeline', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced === 'true') return;
        this.dataset.enhanced = 'true';

        const buttons = Array.from(this.querySelectorAll('[data-trade-filter]'));
        const items = Array.from(this.querySelectorAll('[data-trade-item]'));
        const liveRegion = this.querySelector('[data-trade-live]');
        const countTemplate = this.dataset.countTemplate || 'Showing __count__ exhibitions';

        const applyFilter = (filter) => {
          let visibleCount = 0;

          items.forEach((item) => {
            const status = item.dataset.status;
            const visible = filter === 'all' || status === filter || (filter === 'upcoming' && status === 'live');
            item.hidden = !visible;
            if (visible) visibleCount += 1;
          });

          buttons.forEach((button) => {
            const active = button.dataset.tradeFilter === filter;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });

          if (liveRegion) {
            liveRegion.textContent = countTemplate.replace('__count__', String(visibleCount));
          }
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const update = () => applyFilter(button.dataset.tradeFilter);
            if (document.startViewTransition) {
              document.startViewTransition(update);
            } else {
              update();
            }
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
